import angular from 'angular';
import moment from 'moment';
import ngMessages from 'angular-messages';
import lodashRound from 'lodash/round';
import ngTranslate from 'angular-translate';
import 'angular-translate-loader-static-files';
import TkrSpaCommon from '../../../common/tkr-spa';
import { TkrPersonService } from '../../../common/tkr-commonservices';
import { IbanService, IbanValidator } from '../../../common/ma-iban';
import { SmartFloat, SmartInteger } from '../../../common/ma-smartfloat-1.0';
import TkrPpCommon from '../../../pp/common/0-pp-common-module';
import TkrPpResources from '../../../pp/prcportal-resource-modules';
import DatepickerPopup from '../../../common/ma-datepicker-uib';
import TkrCommonResources from '../../../common/commonresources';
import { configureTranslateProvider } from '../../../pp/translation-helpers';
const subsidy_application_app = angular.module('ng-tkr-app-loimaa', [
    TkrSpaCommon,
    ngMessages,
    ngTranslate,
    TkrPersonService,
    IbanValidator,
    IbanService,
    SmartFloat,
    SmartInteger,
    DatepickerPopup,
    TkrPpResources,
    TkrCommonResources,
    TkrPpCommon,
])
    .config(config)
    .config(configureTranslateProvider);
export default subsidy_application_app.name;
config.$inject = ['$stateProvider', '$urlRouterProvider'];
function config($stateProvider, $urlRouterProvider) {
    $urlRouterProvider.otherwise('/err');
    $stateProvider
        .state('err', {
        url: '/err',
        template: '<p class="h4 text-danger">Sisäinen virhe. Ota yhteyttä helpdesk@matriset.fi.</p>'
    })
        .state('root', {
        url: '',
        template: '',
        controller: 'AppRedirCtrl',
        controllerAs: 'vm'
    })
        .state('lomake', {
        url: '/:applicationId',
        template: require('./app.tpl.html'),
        controller: 'SubsidyApplicationController',
        controllerAs: 'vm',
        resolve: {
            app: ['PortalSubsidyAppService', '$stateParams', function (PortalSubsidyAppService, $stateParams) {
                    return PortalSubsidyAppService.get({ appId: $stateParams.applicationId }).$promise;
                }],
            appPeriod: ['PortalAppPeriodService', 'app', function (PortalAppPeriodService, app) {
                    return PortalAppPeriodService.get({ periodId: app.applicationPeriodId }).$promise;
                }],
            session: ['SessionDataService', function (SessionDataService) {
                    return SessionDataService.get().$promise;
                }]
        }
    })
        .state('jatetty', {
        url: '/:applicationId/jatetty',
        template: require('./app-submitted.tpl.html'),
        controller: 'AppSubmittedController',
        controllerAs: 'vm'
    });
}
subsidy_application_app.controller('SubsidyApplicationController', SubsidyApplicationController);
SubsidyApplicationController.$inject = [
    'app',
    'appPeriod',
    'TkrPersonService',
    '$state',
    'session'
];
function SubsidyApplicationController(app, appPeriod, TkrPersonService, $state, session) {
    var vm = this;
    vm.paperAllowed = !!session.permissions.PAPERAPP;
    vm.vuosi = appPeriod.td.wnum.vuosi;
    vm.edvuosi = vm.vuosi - 1;
    vm.loppuAika = moment(appPeriod.end).local().format('D.M.YYYY HH:mm');
    vm.personRoles = TkrPersonService.personRoles;
    vm.chairmanRoles = TkrPersonService.chairmanRoles;
    vm.preprocessApp = function (app) {
        if (!app.chairman) {
            app.chairman = {};
        }
        if (!app.contactPerson) {
            app.contactPerson = {};
        }
        if (!app.td) {
            app.td = {};
        }
        if (!app.td.wnum) {
            app.td.wnum = {};
        }
        if (!app.td.num) {
            app.td.num = {};
        }
        if (app.applicationState == 'INIT' && app.td.wnum.lk && app.td.wnum.lk != 5) {
            app.established = true;
        }
        if (app.submitType == 1 && app.submitTime) {
            vm.paperAppDate = moment(app.submitTime).format('YYYY-MM-DD');
        }
    };
    vm.postprocessApp = function (app) {
        if (!vm.isSeparateChairmanRequired()) {
            if (vm.isChairmanRequired()) {
                app.chairman = app.contactPerson;
            }
            else {
                app.chairman = null;
            }
        }
    };
    vm.preprocessApp(app);
    vm.app = app;
    vm.isChairmanRequired = function () {
        return vm.app.established ? true : false;
    };
    vm.isSeparateChairmanRequired = function () {
        return (vm.isChairmanRequired() &&
            !TkrPersonService.isValidChairmanRole(vm.app.contactPerson.role)) ? true : false;
    };
    vm.save = function () {
        vm.postprocessApp(vm.app);
        vm.app.applicationState = 'SUBMITTED';
        vm.app.$save({ paperDate: vm.paperAppDate }).then(function (data) {
            $state.go('jatetty', { applicationId: data.id });
        });
    };
    vm.saveDraft = function () {
        vm.app.applicationState = 'DRAFT';
        vm.app.$save().then(function (data) {
            vm.draftSaved = true;
        });
    };
    vm.menotYht = function () {
        var o = vm.app.td.num;
        return lodashRound(lodashRound(o.kulutHoito || 0, 2) +
            lodashRound(o.kulutKunnostus || 0, 2) +
            lodashRound(o.kulutHallinto || 0, 2) +
            lodashRound(o.kulutMuu || 0, 2), 2);
    };
    vm.menoBudjYht = function () {
        var o = vm.app.td.num;
        return lodashRound(lodashRound(o.budjHoito || 0, 2) +
            lodashRound(o.budjKunnostus || 0, 2) +
            lodashRound(o.budjHallinto || 0, 2) +
            lodashRound(o.budjMuu || 0, 2), 2);
    };
    vm.tulotYht = function () {
        var o = vm.app.td.num;
        return lodashRound(lodashRound(o.tulotMaksut || 0, 2) +
            lodashRound(o.tulotAvustus || 0, 2) +
            lodashRound(o.tulotMuu || 0, 2), 2);
    };
    vm.tuloBudjYht = function () {
        var o = vm.app.td.num;
        return lodashRound(lodashRound(o.tuloBudjMaksut || 0, 2) +
            lodashRound(o.tuloBudjAvustus || 0, 2) +
            lodashRound(o.tuloBudjMuu || 0, 2), 2);
    };
}
